import { useState } from "react";

import IntroPage1 from "./pages/IntroPage1";
import IntroPage2 from "./pages/IntroPage2";
import IntroPage3 from "./pages/IntroPage3";
import IntroPage4 from "./pages/IntroPage4";

const IntroPage = () => {
  const [currentPage, setCurrentPage] = useState(1);

  let page;

  switch (currentPage) {
    case 1:
      page = <IntroPage1 setCurrentPage={setCurrentPage} />;
      break;
    case 2:
      page = <IntroPage2 setCurrentPage={setCurrentPage} />;
      break;
    case 3:
      page = <IntroPage3 setCurrentPage={setCurrentPage} />;
      break;
    case 4:
      page = <IntroPage4 />;
      break;
    default:
      page = <IntroPage1 setCurrentPage={setCurrentPage} />;
  }

  return page;
};

export default IntroPage;
